/*
Copyright 2022 by Herbert Potechius,
Ernst-Abbe-Hochschule Jena - University of Applied Sciences - Department of Electrical Engineering and Information
Technology - Immersive Media and AR/VR Research Group.
All rights reserved.
This file is released under the "MIT License Agreement".
Please see the LICENSE file that should have been included as part of this package.
*/

// import logo from './logo.svg';
import './App.scss';
import './constants/GlobalStyle.scss';
import Main from './pages/Main/Main'
import Login from './login/Login';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import React from 'react';
import { useEffect, Fragment, useLayoutEffect, useState  } from 'react';
import useToken from './useToken';

const useWindowSize = () => {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    const updateSize = () => {
      setSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return size;
};

function App() {
  const [width, height] = useWindowSize();
  const { token, setToken } = useToken();
  console.log(token)
  //if(!token) {
  //  return <Login setToken={setToken} />
  //}



  document.addEventListener("gesturestart", function (e) {
    e.preventDefault();
      document.body.style.zoom = 1;
  });
  
  document.addEventListener("gesturechange", function (e) {
    e.preventDefault();
  
    document.body.style.zoom = 1;
  });
  document.addEventListener("gestureend", function (e) {
      e.preventDefault();
      document.body.style.zoom = 1;
  });

  return (
    <Router>
    <Routes>
      <Route path="/Sunlit3D" exact element={<Main/>} />
    </Routes>
  </Router>
  );
}

export default App;

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});